<template>
  <div
    ref="containerRef"
    class="vci-container"
  >
    <img
      ref="leftImageRef"
      :src="leftImage"
      :style="leftImageStyle"
      class="left-image"
      alt="Left Image"
    >
    <img
      ref="rightImageRef"
      :src="rightImage"
      class="right-image"
      alt="Right image"
    >
    <div
      :style="sliderStyle"
      class="vci-slider"
    >
      <!--<div class="top-dot"><span class="fa fa-circle"/></div>
      <div class="bottom-dot"><span class="fa fa-circle"/></div>-->
      <div class="middle-dot">
        <img
          :src="DragCircleSvg"
          class="drag-circle"
          alt="Drag to compare"
        >
      </div>
      <div
        :style="sliderLineStyle"
        class="line"
      />
      <div
        :style="sliderLineStyle"
        class="line"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { ResizeSensor } from 'css-element-queries'
import DragCircleSvg from '../svg/drag-circle.svg'

export default Vue.extend({
  props: {
    leftImage: {
      type: String,
      default: ''
    },
    // under image
    rightImage: {
      type: String,
      default: ''
    },
    hover: {
      type: Boolean,
      default: false
    },
    handleSize: {
      type: Number,
      default: 40
    },
    sliderLineWidth: {
      type: Number,
      default: 4
    },
    sliderPositionPercentage: {
      type: Number,
      default: 0.5
    },
    resetParam: {
      type: [Number, String, Boolean],
      default: null
    }
  },
  data () {
    return {
      // slider position percentage(0 to 1)
      positionPct: this.sliderPositionPercentage || 0.5,
      imageWidth: 0,
      DragCircleSvg
    }
  },
  computed: {
    // eslint-disable
    leftImageStyle () {
      return {
        clip:
          'rect(auto, ' + this.imageWidth * this.positionPct + 'px, auto, auto)'
      }
    },
    sliderStyle () {
      return {
        cursor: !this.hover && 'ew-resize',
        left: this.imageWidth * this.positionPct - this.handleSize / 2 + 'px',
        width: `${this.handleSize}px`
      }
    },
    sliderLineStyle () {
      return { width: `${this.sliderLineWidth}px` }
    }
  },
  watch: {
    resetParam (v, ov) {
      if (v !== ov) {
        this.positionPct = this.sliderPositionPercentage || 0.5
      }
    }
  },
  mounted () {
    // get and set `imageWidth` when the container size changed
    // (including first time rendering)
    //
    // eslint-disable-next-line
    new ResizeSensor(this.$refs.containerRef, () => {
      this.getAndSetImageWidth()
    })

    const containerElement = this.$refs.containerRef

    // for mobile
    containerElement.addEventListener('touchstart', this.startSliding)
    window.addEventListener('touchend', this.finishSliding)

    // for desktop
    if (this.hover) {
      containerElement.addEventListener('mouseenter', this.startSliding)
      containerElement.addEventListener('mouseleave', this.finishSliding)
    } else {
      containerElement.addEventListener('mousedown', this.startSliding)
      window.addEventListener('mouseup', this.finishSliding)
    }
  },
  beforeDestroy () {
    this.finishSliding()
    window.removeEventListener('mouseup', this.finishSliding)
    window.removeEventListener('touchend', this.finishSliding)
  },
  methods: {
    getAndSetImageWidth () {
      // @ts-ignore
      this.imageWidth = this.$refs.rightImageRef.getBoundingClientRect().width
    },
    startSliding (e) {
      // Prevent default behavior other than mobile scrolling
      if (!('touches' in e)) {
        e.preventDefault()
      }

      // Slide the image even if you just click or tap (not drag)
      this.updateSliderPosition(e)

      window.addEventListener('mousemove', this.updateSliderPosition)
      window.addEventListener('touchmove', this.updateSliderPosition)
    },
    finishSliding () {
      window.removeEventListener('mousemove', this.updateSliderPosition)
      window.removeEventListener('touchmove', this.updateSliderPosition)
    },
    updateSliderPosition (event) {
      const e = event || window.event

      // Calc Cursor Position from the left edge of the viewport
      const cursorXfromViewport = e.touches ? e.touches[0].pageX : e.pageX

      // Calc Cursor Position from the left edge of the window (consider any page scrolling)
      const cursorXfromWindow = cursorXfromViewport - window.pageXOffset

      // Calc Cursor Position from the left edge of the image
      const imagePosition = this.$refs.rightImageRef.getBoundingClientRect()
      let pos = cursorXfromWindow - imagePosition.left

      const minPos = 0 + this.sliderLineWidth / 2
      const maxPos = this.imageWidth - this.sliderLineWidth / 2

      if (pos < minPos) pos = minPos
      if (pos > maxPos) pos = maxPos

      this.positionPct = pos / this.imageWidth
    }
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vci-container {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  overflow: hidden;
}

.right-image {
  display: block;
  height: auto; // Respect the aspect ratio
  width: 100%;
}

.left-image {
  display: block;
  height: 100%; // fit to the height of under image
  object-fit: cover; // protrudes is hidden
  position: absolute;
  top: 0;
  width: 100%;
}

.vci-slider {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  top: 0;

  .line {
    background: $grad-color-purple;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    flex: 0 1 auto;
    height: 100%;
  }

  .top-dot,
  .bottom-dot,
  .middle-dot {
    position: absolute;
    left: 13px;
    color: #999;
    font-size: 16px;

    & .fa {
      -webkit-text-fill-color: #fff;
      -webkit-text-stroke-width: 3px;
      -webkit-text-stroke-color: $grad-color-purple;
    }
  }

  .top-dot {
    top: -4px;
  }

  .bottom-dot {
    bottom: -4px;
  }

  .middle-dot {
    top: 46%;
    left: 3px;
    color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/VueCompareImage.vue